export const compareString = (a, b, reverse = false) => {
    let first = reverse ? b : a;
    let second = reverse ? a : b;

    if (first === undefined || second === undefined) return 0;

    return first.localeCompare(second, undefined, {
        numeric: true,
        sensitivity: "base",
    });
};

export const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export const distinct = (value, index, array) => array.indexOf(value) === index;

export const isEmpty = (str) => !str || str.length === 0;

export const isHttpSecure = () => window.location.protocol.startsWith("https");

export const padDigits = (num, length = 2, fillWith = "0") =>
    num.toString().padStart(length, fillWith);

export const titleCase = (str) => str.charAt(0) + str.slice(1);
